import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ActivatedRoute, Router, RouterLink } from '@angular/router'

import { CaseListComponent } from '../../../abacus/components/case-list.component'
import { InputType } from '../../../abacus/enums/input-type.enum'
import { Filter } from '../../../abacus/interfaces/filter.interface'
import { ResourceDefinition } from '../../../abacus/interfaces/resource-definition.interface'
import { Yield } from '../../../abacus/interfaces/yield.interface'
import { AuthService } from '../../../abacus/services/auth.service'
import { BreadcrumbService } from '../../../abacus/services/breadcrumb.service'
import { FilterService } from '../../../abacus/services/filter.service'
import { FlashMessageService } from '../../../abacus/services/flash-message.service'
import { ResourceService } from '../../../abacus/services/resource.service'
import { caseListTemplate } from '../../../abacus/templates/case-list.template'
import { HasPermissionDirective } from '../../../abacus/directives/has-permission.directive'
import { CaseInputComponent } from '../../../abacus/elements/inputs/case-input/case-input.component'
import { MetaComponent } from '../../../abacus/elements/partials/meta/meta.component'
import { TableComponent } from '../../../abacus/elements/partials/table/table.component'
import { PaginationComponent } from '../../../abacus/elements/partials/pagination/pagination.component'
import { EurosPipe } from 'src/app/abacus'
import { transparencyReportDefinition } from '../transparency-report.definition'
import { getCompletedQuarterOptions } from '../transparency-report.utils'
import { transparencyReportYields } from '../transparency-report.yields'
import { oecdCountries } from '../../../shared/data/oecd-countries'

@Component({
  template: caseListTemplate,
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    HasPermissionDirective,
    CaseInputComponent,
    MetaComponent,
    TableComponent,
    PaginationComponent,
    EurosPipe
  ]
})
export class TransparencyReportListComponent
  extends CaseListComponent
  implements OnInit
{
  definition: ResourceDefinition = transparencyReportDefinition
  yields: Yield[] = transparencyReportYields

  filters: Filter[] = [
    {
      label: 'Search a report',
      placeholder: 'Search by organization, name or email...',
      property: 'terms',
      inputType: InputType.Text,
      className: 'is-12'
    },
    {
      label: 'Reporting Period',
      property: 'reportingPeriod',
      placeholder: 'Select a period',
      inputType: InputType.Select,
      className: 'is-3',
      selectOptions: [
        { label: 'All periods', value: 'null' },
        ...getCompletedQuarterOptions()
      ]
    },
    {
      label: 'Status',
      property: 'status',
      placeholder: 'Select a status',
      inputType: InputType.Select,
      className: 'is-3',
      selectOptions: [
        { label: 'All status', value: 'null' },
        { label: 'Published', value: 'published' },
        { label: 'Pending Review', value: 'pending_review' },
        { label: 'Unchanged', value: 'unchanged' },
        { label: 'Draft', value: 'draft' }
      ]
    },
    {
      label: 'Country',
      property: 'country',
      placeholder: 'Select a country',
      inputType: InputType.Select,
      className: 'is-3',
      selectOptions: [
        { label: 'All countries', value: 'null' },
        ...oecdCountries.map(c => ({ label: c.label, value: c.value }))
      ]
    },
    {
      label: 'Version',
      property: 'versionKey',
      placeholder: 'Select a version',
      inputType: InputType.Select,
      className: 'is-3',
      selectOptions: [
        { label: 'All versions', value: 'null' },
        { label: 'v1', value: 'v1' },
        { label: 'v2', value: 'v2' }
      ]
    }
  ]

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService,
    authService: AuthService,
    filterService: FilterService
  ) {
    super(
      router,
      activatedRoute,
      breadcrumbService,
      resourceService,
      flashMessageService,
      authService,
      filterService
    )
  }

  ngOnInit() {
    this.initListView()
  }

}
